// constants

// action_component_subject
const SET_TOTO_PLACE_BET = "SET_TOTO_PLACE_BET";
const RESET_TOTO_PLACE_BET = "RESET_TOTO_PLACE_BET";
const RESET_TOTO_PLACE_BET_NUMBER = "RESET_TOTO_PLACE_BET_NUMBER";

const SET_TOTO_PLACE_BET2 = "SET_TOTO_PLACE_BET2";
const APPEND_TOTO_PLACE_BET = "APPEND_TOTO_PLACE_BET";

// reducers

const initialState = {};

const Reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_TOTO_PLACE_BET:
      return { ...action.payload };
    case RESET_TOTO_PLACE_BET:
      return {};
    case RESET_TOTO_PLACE_BET_NUMBER:
      return { ...state, formPlaceBet: [] };

    case SET_TOTO_PLACE_BET2:
      return {
        selectedDraw: "Current",
        formPlaceBet: [...action.payload],
      };

    case APPEND_TOTO_PLACE_BET:
      if (Object.entries(state).length > 0)
        return {
          ...state,
          formPlaceBet: [...state?.formPlaceBet, ...action.payload],
        };
      else
        return {
          selectedDraw: "Current",
          formPlaceBet: [...action.payload],
        };

    default:
      return state;
  }
};

export default Reducer;

// actions

export const setTotoPlaceBet = (payload) => {
  return {
    type: SET_TOTO_PLACE_BET,
    payload: payload,
  };
};

export const setTotoPlaceBet2 = (payload) => {
  return {
    type: SET_TOTO_PLACE_BET2,
    payload: payload,
  };
};

export const appendTotoPlaceBet = (payload) => {
  return {
    type: APPEND_TOTO_PLACE_BET,
    payload: payload,
  };
};

export const resetTotoPlaceBet = () => {
  return {
    type: RESET_TOTO_PLACE_BET,
  };
};

export const resetTotoPlaceBetNumber = () => {
  return {
    type: RESET_TOTO_PLACE_BET_NUMBER,
  };
};
